import { HttpMethod } from '@nu-art/thunderstorm-shared';
import { DBDef_FHIRResource } from './db-def.js';
export const ApiDef_FHIRResourceGroup = {
    _v1: {
        createFromJSON: { method: HttpMethod.POST, path: `/v1/${DBDef_FHIRResource.dbKey}/create-from-json` }
    }
};
//# sourceMappingURL=api-def.js.map